import React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import propTypes from "prop-types";
import { studiesOperations } from "../../Studies/duck/index";

const PREFIX = "Status";

const classes = {
  container: `${PREFIX}-container`,
  StudyFinished: `${PREFIX}-StudyFinished`,
  badge: `${PREFIX}-badge`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(() => ({
  [`& .${classes.container}`]: {
    position: "absolute",
    top: "14px",
    zIndex: 1,
    right: "144px",
    width: "fit-content",
  },

  [`& .${classes.StudyFinished}`]: {
    padding: "2px 4px !important",
    color: "#4caf50",
  },

  [`& .${classes.badge}`]: {
    position: "relative",
    top: "11px",
    right: "98px",
  },
}));

const Status = ({ studiesOverview }) => {
  const { status, live, completed } = studiesOverview;

  return (
    <Root>
      <Grid
        alignItems="center"
        className={classes.container}
        container
        spacing={2}
        style={{ position: "fixed" }}
      >
        {status === "Live" && live === true && completed === false ? (
          <>
            <Grid item>
              <Alert
                variant="outlined"
                icon={false}
                severity="error"
                style={{ padding: "0px 8px" }}
              >
                <Badge
                  classes={{
                    badge: classes.badge,
                  }}
                  variant="dot"
                  color="error"
                  style={{ paddingLeft: "20px" }}
                >
                  <Typography component={"span"} color="error" variant="button">
                    LIVE STUDY
                  </Typography>
                </Badge>
              </Alert>
            </Grid>
          </>
        ) : (
          <Grid className={classes.StudyFinished} item>
            <Alert
              variant="filled"
              icon={<CheckIcon fontSize="inherit" />}
              severity="success"
            >
              {completed
                ? "Study completed"
                : "Lumen is processing your results!"}
            </Alert>
          </Grid>
        )}
      </Grid>
    </Root>
  );
};

const mapStateToProps = (state) => {
  return {
    studiesOverview: state.isolationData.studiesOverview,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postEndLiveStudy: (id) => dispatch(studiesOperations.postEndLiveStudy(id)),
  };
};

Status.propTypes = {
  studiesOverview: propTypes.object,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Status));
